import { ArrowDownOutlined, ArrowUpOutlined } from '@ant-design/icons';
import { useTranslation } from '@framework/i18n';
import { Tooltip } from 'antd';
import React from 'react';

export interface IPositiveNegativeNumberProps {
  value: number;
}

/**
 * Mostra un numero con un indicatore di "positivo"/"negativo" (con colori diversi).
 */
export function PositiveNegativeNumber(props: IPositiveNegativeNumberProps) {
  const { value } = props;

  const absoluteValue = Math.abs(value);

  const isNegative = value < 0;

  const { t } = useTranslation();

  return (
    <>
      {isNegative && value !== 0 && (
        <Tooltip title={t('carenza', 'Carenza')}>
          <ArrowDownOutlined style={{ color: 'red' }} />
        </Tooltip>
      )}
      {!isNegative && value !== 0 && (
        <Tooltip title={t('eccedenza', 'Eccedenza')}>
          <ArrowUpOutlined style={{ color: 'green' }} />
        </Tooltip>
      )}
      {absoluteValue}
    </>
  );
}
